import {
  ContractLinkCreateAction,
  contractLinkCreateLoadPdfSuccess,
} from '@app/features/contractLink/contractLinkCreate';
import * as TYPES from '@app/store/actionTypes';
import { TemplateAction } from '@app/store/template/actions';

type TemplateUrlState = string;

const initialState: TemplateUrlState = '';

export default function reducer(
  state: TemplateUrlState = initialState,
  action: TemplateAction | ContractLinkCreateAction
) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
      return initialState;
    case contractLinkCreateLoadPdfSuccess.type:
    case TYPES.TEMPLATE_CREATE__PDF_LOAD_SUCCESS:
    case TYPES.TEMPLATE_FILE_CHANGE__PDF_LOAD_SUCCESS:
      return action.payload.url;
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
      return action.payload.file.url;
    default:
      return state;
  }
}
